import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "carReturn"
const CarReturnIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.034 16.045H4.273a.91.91 0 0 1-.91-.909V9.682c0-.312.01-.62.026-.922a1.591 1.591 0 1 1 .537-3.134C4.692 3.154 6.217 1.5 8.364 1.5h6.363c2.146 0 3.672 1.654 4.438 4.126a1.59 1.59 0 0 1 .537 3.134c.017.302.025.61.025.922v1.303L18.364 9.62a3 3 0 0 0-4.553 3.879H9c-.748 0-1.433.274-1.958.727H7v.037a2.995 2.995 0 0 0-.966 1.781v.001Zm-.398-8.181c0-.91 0-4.546 3.182-4.546h5.455c3.182 0 3.182 3.637 3.182 4.546H5.636Zm-.302 3.874a1.364 1.364 0 1 0 2.35-1.385 1.364 1.364 0 0 0-2.35 1.385Z"
          />
          <path d="M8.729 17.419h9.514l-2.848 3.253c-.353.406-.303 1.084.1 1.452.41.375 1.091.318 1.455-.1l4.339-4.958c.331-.442.326-.95.002-1.35l-.002-.002-4.339-4.96a1.03 1.03 0 0 0-1.453-.101c-.41.355-.458 1.043-.102 1.453l2.848 3.253H8.729a1.03 1.03 0 1 0 0 2.06Z" />
        </svg>
      }
    </span>
  )
}
export default CarReturnIcon
